const navCards = [
  {
    title: 'gasto cartão',
    path: '/app',
    icon: 'mdi:tag-add',
    color:'#d1e1d1',
    describe:'aqui você adiciona seus cartoes'
  },
  {
    title: 'gasto manual',
    path: '/finacas',
    icon: 'gala:add',
    color:'#ecebf3',
    describe:'aqui você adiciona seus cartoes manualmente'
  },
  {
    title: 'Analytics',
    path: '/user',
    icon: 'ion:analytics-outline',
    color:"#f5efe8",
    describe:'analize seus gastos'
  },
  {
    title: 'todos os gastos',
    path: '/tarefas',
    icon: 'ic:sharp-open-in-new',
    color:'#ecebf3',
    describe:'aqui você ve todos os seus gastos'
  },


];

export default navCards;
